import React, { useState, useEffect, useRef } from "react";

export default function SlotDisplay({
  data,
  totalItemCount,
  totalLargeCount,
  showAmontTicket,
  showTypeTicket,
  showScannedBox,
  randomSlots,
  showMeta,
  themeValues,
}) {
  const divRef = useRef(null);

  let totalCount = totalItemCount + totalLargeCount;
  const [rows, setRows] = useState(10);

  const getBoundryColor = (data) => {
    if (themeValues?.borderColor?.[data.lottery.amount]) {
      return {
        borderColor: themeValues?.borderColor?.[data.lottery.amount],
        boxColor: themeValues?.boxColor?.[data.lottery.amount],
        fontColor: themeValues?.fontColor?.[data.lottery.amount],
        boxBorderWidth: themeValues?.boxBorderWidth?.[data.lottery.amount],
      };
    } else {
      return {
        borderColor: themeValues?.borderColor?.[1],
        boxColor: themeValues?.boxColor?.[1],
        fontColor: themeValues?.fontColor?.[1],
        boxBorderWidth: themeValues?.boxBorderWidth?.[1],
      };
    }
  };

  const getTicketMeta = (data) => {
    const packSize = data.lottery.pack_size;
    const isReversed = data.is_reverse;
    const currentNo = data.current_no;

    let ticketMeta = { ticketMeta: "CURRENT NUMBER", ticketType: [-1] };

    if (data.lottery.is_new == 1) {
      ticketMeta = { ticketMeta: "NEW TICKET", ticketType: [-1, 1] };
    }

    if (isReversed) {
      if (currentNo < 5) {
        ticketMeta = {
          ticketMeta: `ONLY ${currentNo + 1} LEFT`,
          ticketType: [3, ...ticketMeta.ticketType],
        };
      }
    } else {
      if (packSize - 1 - currentNo <= 5) {
        ticketMeta = {
          ticketMeta: `ONLY ${packSize - currentNo} LEFT`,
          ticketType: [3, ...ticketMeta.ticketType],
        };
      }
    }

    return ticketMeta;
  };

  const getCardWidthHeight = () => {
    const topMargin = 10;
    let avlheight = divRef.current.clientHeight - topMargin;
    let avlWidth = divRef.current.clientWidth;
    let totalArea = avlWidth * avlheight;

    let cardArea = totalArea / totalCount;

    let cardWidth = Math.sqrt(cardArea / themeValues?.cardRatio);

    let tmaxCardInRow = Math.floor(avlWidth / cardWidth, 10);

    setRows(tmaxCardInRow);
  };

  useEffect(() => {
    if (data && totalItemCount && themeValues?.cardRatio) {
      getCardWidthHeight();
    }
  }, [data, totalItemCount, themeValues?.cardRatio]);

  useEffect(() => {
    const handleWindowResize = () => {
      console.log("window resized");

      if (data && totalItemCount) {
        getCardWidthHeight();
      }
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  return (
    <div
      ref={divRef}
      style={{
        height: "100%",
        width: "100%",
        display: "grid",
        gridTemplateColumns: `repeat(${rows}, 1fr)`,
        gridGap: 4,
        gridAutoFlow: "row",
        gridAutoRows: "1fr",
        justifyItems: "center",
        alignItems: "start",
        padding: "0.5%",
      }}
    >
      {data.map((item, index) => {
        const boundryColor = getBoundryColor(item);

        const { ticketMeta, ticketType } = getTicketMeta(item);
        const gridBalance = rows - (totalCount % rows);

        return (
          <div
            key={item?.slot_number}
            style={{
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: themeValues?.borderRadius,
              overflow: "hidden",
              display: "flex",
              backgroundImage: `url(${item?.lottery?.image_url.replace(
                "",
                ""
              )})`,
              backgroundSize: "100% auto",
              backgroundRepeat: "repeat-y",
              backgroundPosition: "top",
              // alignItems: verticalPosition ?? "center",
              // justifyContent: horizontalPosition ?? "center",
              alignItems: "center",
              justifyContent: "center",
              gridColumn: `${
                index === totalItemCount - (totalCount % rows)
                  ? `${
                      gridBalance % 2 == 0
                        ? Math.ceil(gridBalance / 2) + 1
                        : Math.ceil(gridBalance / 2)
                    } /`
                  : ""
              } span ${item.size === "large" ? 2 : 1}`,
            }}
            className={`${
              item?.lottery?.amount == showAmontTicket ||
              ticketType.some((t) => t == showTypeTicket) ||
              showScannedBox == item.slot_number ||
              (showTypeTicket == 2 && randomSlots.indexOf(index) >= 0)
                ? "shake"
                : ""
            } ${showScannedBox == item.slot_number ? "flip" : ""}`}
          >
            {/* <Image
                preview={false}
                width={getCardWidthHeight().width - 2 * itemMargin}
                height={getCardWidthHeight().height - 2 * itemMargin}
                src={item?.lottery?.image_url.replace("/thumbnail", "")}
                style={{
                  position: "absolute",
                  left: '0%',
                  top: "0%",
                  right:'0%',
                  margin: '0 auto',              }}
              /> */}
            {/* <div
              style={{
                width: `100%`,
                height: `100%`,
              }}
            ></div> */}
            <div
              style={{
                zIndex: 20,
                color:
                  themeValues?.boxTextColor?.[item?.lottery?.amount] ?? "white",
                // height: "2.5em",
                // width: "2.5em",
                // borderRadius: "50%",
                // transform:'rotate(45deg)',
                transform: `translate(${
                  themeValues?.boxPosition?.horizontalPosition?.[
                    item?.lottery?.amount
                  ] ?? 0
                }px, ${
                  themeValues?.boxPosition?.verticalPosition?.[
                    item?.lottery?.amount
                  ] ?? 0
                }px)`,
                // transform: "translate(50px, 100px)",
                backgroundColor:
                  themeValues?.centerBoxColor?.[item?.lottery?.amount] ??
                  "#000",
                textAlign: "center",
                alignItems: "center",
                fontWeight: 800,
                fontSize: "calc(0.8vh + 0.6vw)",
                // fontSize: 16,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                clipPath:
                  "polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)",
                padding: 8,
                aspectRatio: 1,
              }}
            >
              <span
                style={{
                  // fontSize: ".8vw",
                  fontSize:
                    themeValues?.centerBoxFontSize?.[item?.lottery?.amount] ??
                    "calc(0.4vh + 0.4vw)",
                  // transform: 'rotate(-45deg)',
                  lineHeight: 1,
                }}
              >
                BOX
                <br />
                {item?.slot_number}
              </span>
              {/* <span style={{
                    transform: 'rotate(-45deg)',
                    lineHeight: "1vw"
                  }}></span> */}
            </div>
            <div
              style={{
                position: "absolute",
                left: 0,
                display: "inline",
                top: 0,
                color: "black",
                // height: "15%",
                // width: "wrap",
                fontSize: "calc(0.5vh + 0.5vw)",
                borderRadius: "15%",
                backgroundColor: "white",
                textAlign: "left",
                alignItems: "center",
                fontWeight: 800,
                padding: "2px",
                aspectRatio: "1/1",
              }}
            >
              <sup style={{ alignItems: "flex-start" }}>$</sup>
              {item?.lottery?.amount}
            </div>

            <div
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                border:
                  `${boundryColor?.boxBorderWidth ?? 1}px solid ` +
                  boundryColor?.borderColor,
                top: 0,
                left: 0,
                borderRadius: themeValues?.borderRadius,
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            ></div>

            <div
              style={{
                // height: "18%",
                width: "100%",
                position: "absolute",
                border: "1.8px solid black",
                bottom: themeValues?.translateY?.[item?.lottery?.amount] ?? 0,
                left: "0px",
                backgroundColor: boundryColor?.boxColor,
                padding: "2px 0px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: ".6vw",
                borderRadius: themeValues?.bottomBoxBorderRadius,
                color: boundryColor?.fontColor ?? "#fff",
              }}
            >
              <div
                className={
                  !ticketType.some((t) => t == 3) || !showMeta ? "" : "blink"
                }
                style={{
                  paddingLeft: 4,
                  fontWeight: "600",
                  fontSize:
                    themeValues?.bottomBoxFontSize?.[item?.lottery?.amount] ??
                    "calc(0.3vh + 0.3vw)",
                  fontFamily: "Quantico",
                }}
              >
                {showMeta ? ticketMeta : "CURRENT NUMBER"}
              </div>
              <div
                style={{
                  paddingRight: 4,
                  fontSize:
                    themeValues?.bottomBoxFontSize?.[item?.lottery?.amount] ??
                    "calc(0.3vh + 0.3vw)",
                  fontWeight: 800,
                }}
              >
                {item?.current_no}
              </div>
            </div>

            {item.lottery.is_new == 1 && (
              <div
                style={{
                  borderBottom: `10px solid ${
                    themeValues?.tagBox?.boxColor?.[item?.lottery?.amount] ??
                    "red"
                  }`,
                  borderLeft: "10px solid transparent",
                  borderRight: "10px solid transparent",
                  margin: "auto",
                  position: "absolute",
                  height: "10px",
                  top: 5,
                  right: -10,
                  width: 40,
                  transform: "rotateZ(45deg)",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "calc(46%)",
                    fontWeight: 800,
                    color:
                      themeValues?.tagBox?.fontColor?.[item?.lottery?.amount] ??
                      "white",
                  }}
                >
                  NEW
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
